import type { FunctionComponent } from 'react'

import styles from './article-thumbnails.module.scss'
import type { SectionOfThumbnailsFragment } from '../../graphql/fragments/SectionOfThumbnailsFragment.graphql'
import SectionOfThumbnails from '../section-of-thumbnails/section-of-thumbnails'

/**
 * Renders a section of thumbnails, styled for articles.
 */
export const ArticleThumbnails: FunctionComponent<
    SectionOfThumbnailsFragment
> = (props) => (
    <div className={styles.section}>
        <SectionOfThumbnails {...props} />
    </div>
)
